export const updateObject = (oldObject, updatedProperties) => {
	return {
		...oldObject,
		...updatedProperties,
	};
};

export const updateArray = ([oldArray, newObject]) => {
	return [...oldArray, newObject];
};
